var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasksNavigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23826 0.7146C1.18766 0.7146 0.333496 1.5741 0.333496 2.63127V12.2146C0.333496 13.2718 1.18766 14.1313 2.23826 14.1313H11.7621C12.8127 14.1313 13.6668 13.2718 13.6668 12.2146V2.63127C13.6668 1.5741 12.8127 0.7146 11.7621 0.7146H2.23826ZM10.3633 6.01538L6.55373 9.84871C6.27397 10.1302 5.82159 10.1302 5.54481 9.84871L3.64004 7.93205C3.36028 7.65054 3.36028 7.19533 3.64004 6.91681C3.91981 6.6383 4.37219 6.6353 4.64897 6.91681L6.04778 8.32437L9.35135 4.99715C9.63112 4.71564 10.0835 4.71564 10.3603 4.99715C10.6371 5.27866 10.64 5.73387 10.3603 6.01239L10.3633 6.01538Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksNavigation);
export default __webpack_public_path__ + "static/media/tasks-navigation.ba564dd46af6bfe3f1d38f7543071e12.svg";
export { ForwardRef as ReactComponent };